import { useDebugValue } from 'react';
import { useClauseConditionsWatch } from '../watchers/useClauseConditionsWatch';

export const useHasMultipleConditions = () => {
  const hasMultipleConditions = useClauseConditionsWatch().length > 1;
  useDebugValue(hasMultipleConditions);
  return hasMultipleConditions;
};
